import axios from "axios";
import moment from "moment";

import { config } from "../../config";
import { LocalStorage } from '@/data/localstorage';
import { QueryInfo } from '@/util';
import { User } from '@/entity/authentication/user';


export class ManageUserDetails {
    
    async getUserDetails(userName: string) {
        try {
            let response = await axios.get(config.api.host + "/admin/"+ userName, {
                headers : {
                    Authorization: new LocalStorage().authToken
                }
            });
            return response.data.data;
        } catch(err) {
            return err;
        }
        
    }

    async getUserPaymentHistoryByPage(page: number, size: number, userId: string): Promise<any> {
       
        let queryInfo: any = {
            page: page,
            "page-size" : size,
            userId: userId
        }

        let response = await axios.get(config.api.host + "/admin/getUserPaymentHistory" + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response)
    }
}